export default [
  {
    path: '/certification/company',
    component: () => import('@/views/certification/index.vue'),
  },
]